import { render, staticRenderFns } from "./ovrz2.vue?vue&type=template&id=3f7e5102"
import script from "./ovrz2.vue?vue&type=script&lang=js"
export * from "./ovrz2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports